import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';
const TokenSession = 'Session-Token';

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getSession() {
  return Cookies.get(TokenSession);
}

export function setSession(token) {
  return Cookies.set(TokenSession, token);
}

export function removeSession() {
  return Cookies.remove(TokenSession);
}
